
import { Component, ActionButtonConfig, FormModalMixins, Watch,appConst } from "@/lib";
import LogisticsCost from "@/store/modules/shipment/logisticscost/logisticscost";

@Component({name:"edit-security-item-modal"})
export default class EditSecurityItemModal extends FormModalMixins {
  model = new LogisticsCost();

  

 get record() {
    return this.$store.state.shipment.logisticscost.securityItem;
  }
  async created(){
    await this.$store.dispatch("system/logistics/getLogisticsList");
  }
get salesType(){
  return this.$store.state.shipment.logisticscost.editLogisticsCost
}
get currencyList() {
    return this.getCodeListByCategory(appConst.codeCategory.currency)
  }
  resetModel(){
    this.model = new LogisticsCost();
  
  }

  cancel(){
    this.$emit("cancel");
  }

 close() {
    this.config.isShow = false;
    this.model = new LogisticsCost();
  }
 get logisticsList() {
    return this.$store.state.system.logistics.logisticsLists;
  }

}
